/* FollicGen - reviews marquee. Loads AFTER follicgen.js so it overrides the
   "show 6 + Ver mas" behaviour and turns the review grid into a continuous
   right-to-left marquee (pauses on hover). Scrolls whatever review blocks
   exist on the page (all editable in the theme editor). */
(function () {
  var CSS =
    '.fg-mq{overflow:hidden;padding-block:8px;-webkit-mask-image:linear-gradient(90deg,transparent,#000 4%,#000 96%,transparent);mask-image:linear-gradient(90deg,transparent,#000 4%,#000 96%,transparent)}' +
    '.fg-mq__track{display:flex;gap:18px;width:max-content;will-change:transform;animation:fg-mq-scroll linear infinite}' +
    '.fg-mq:hover .fg-mq__track{animation-play-state:paused}' +
    '.fg-mq__track .review-card{flex:0 0 320px;width:320px;margin:0}' +
    '@keyframes fg-mq-scroll{from{transform:translateX(0)}to{transform:translateX(-50%)}}' +
    '@media (max-width:760px){.fg-mq__track .review-card{flex-basis:80vw;width:80vw}}' +
    '@media (prefers-reduced-motion:reduce){.fg-mq__track{animation:none}.fg-mq{overflow-x:auto}}';
  function injectCss() { if (document.getElementById('fg-mq-css')) return; var st = document.createElement('style'); st.id = 'fg-mq-css'; st.textContent = CSS; (document.head || document.documentElement).appendChild(st); }
  function build(section) {
    var grid = section.querySelector('.review-grid');
    if (!grid || grid.getAttribute('data-fg-mq')) return;
    var cards = [].slice.call(grid.querySelectorAll('.review-card'));
    if (cards.length < 2) return;
    grid.setAttribute('data-fg-mq', '1');
    var more = section.querySelector('.reviews-more'); if (more) more.style.display = 'none';
    var track = document.createElement('div'); track.className = 'fg-mq__track';
    cards.forEach(function (c) { c.style.display = ''; track.appendChild(c); });
    var unique = track.children.length;
    track.innerHTML = track.innerHTML + track.innerHTML;
    var kids = [].slice.call(track.children);
    for (var i = unique; i < kids.length; i++) { kids[i].setAttribute('aria-hidden', 'true'); }
    track.style.animationDuration = (unique * 4) + 's';
    grid.className = 'fg-mq';
    grid.innerHTML = '';
    grid.appendChild(track);
  }
  function run() { injectCss(); [].slice.call(document.querySelectorAll('[data-fg-reviews]')).forEach(build); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();
